import { Container, Divider, Grid, Grid2, Stack } from "@mui/material";
import { ReactElement } from "react";
import { TitleView } from "./TitleView";

interface props {
  title: string;
  titleLayout?: ReactElement;
  layout?: ReactElement;
  isLayoutFullWidthInSmallerScreens?: boolean;
  hasDivider?: boolean;
}

export const HeaderView: React.FC<props> = ({
  title,
  titleLayout,
  layout,
  isLayoutFullWidthInSmallerScreens = true,
  hasDivider = true,
}: props) => {
  return (
    <Stack>
      <Container maxWidth={false} sx={{ p: 2 }}>
        <Grid2 container spacing={2} alignItems={"center"}>
          <Grid2
            size={{
              xs: isLayoutFullWidthInSmallerScreens ? 12 : 6,
              sm: isLayoutFullWidthInSmallerScreens ? 12 : 6,
              md: 6,
              lg: 6,
              xl: 3,
            }}
          >
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <TitleView title={title} />
              {titleLayout}
            </Stack>
          </Grid2>
          <Grid2
            size={{ xl: 3 }}
            display={{
              xs: "none",
              sm: "none",
              md: "none",
              lg: "none",
              xl: "block",
            }}
          />
          <Grid2
            size={{ xl: 3 }}
            display={{
              xs: "none",
              sm: "none",
              md: "none",
              lg: "none",
              xl: "block",
            }}
          />
          {layout && (
            <Grid2
              size={{
                xs: isLayoutFullWidthInSmallerScreens ? 12 : 6,
                sm: isLayoutFullWidthInSmallerScreens ? 12 : 6,
                md: 6,
                lg: 6,
                xl: 3,
              }}
            >
              {layout}
            </Grid2>
          )}
        </Grid2>
      </Container>
      {hasDivider && <Divider />}
    </Stack>
  );
};
